// Garantievoorwaarden DT Timmerwerken. {email} en {telefoon} worden ingevuld vanuit de site-instellingen.
export const garantieVersie = "Versie oktober 2026";

export const garantieTermijnen = [
  {
    duur: "10 jaar",
    titel: "Houtconstructies, kozijnen en montage",
    tekst:
      "Op door mij gemaakte en gemonteerde houtconstructies zoals dakkapellen, veranda's en overkappingen, houtskeletbouwwanden, erkers en aanbouwen, op houten kozijnen en deuren en op de bijbehorende montage, waaronder de water- en winddichte aansluiting op de bestaande constructie.",
  },
  {
    duur: "5 jaar",
    titel: "Gevelbekleding, afwerking en herstelwerk",
    tekst:
      "Op houten gevelbekleding en boeidelen, op aftimmerwerk en binnenafwerking, op houtrotherstel en deelvervanging en op overige herstelwerkzaamheden aan bestaande onderdelen. Voor buitenhoutwerk geldt de onderhoudsvoorwaarde dat kit- en schilderwerk tijdig wordt onderhouden (zie voorwaarden).",
  },
  {
    duur: "3 jaar",
    titel: "Kit- en afdichtingswerk",
    tekst:
      "Op kitvoegen, afdichtingen en aansluitingen die ik aanbreng, mits deze niet mechanisch worden belast of door derden zijn bewerkt.",
  },
  {
    duur: "Fabrieksgarantie",
    titel: "Glas, beslag, dakbedekking en overige producten",
    tekst:
      "Op isolatieglas (HR++, triple), hang- en sluitwerk, dakramen, dakbedekking (EPDM, polycarbonaat), verf- en beitsproducten en overige geleverde producten geldt de garantie volgens de voorwaarden en termijn van de fabrikant of leverancier. Ik help je bij het indienen van een fabrieksgarantieclaim.",
  },
];

export const garantieDekking = [
  "Gebreken in de uitvoering van mijn timmer-, montage- of herstelwerkzaamheden",
  "Lekkages die aantoonbaar door mijn werkzaamheden zijn veroorzaakt",
  "Loslatende, kromtrekkende of loszittende onderdelen die door mij zijn gemaakt of geplaatst, voor zover dit niet valt onder de normale werking van hout",
  "Constructieve gebreken in door mij gemaakte houtconstructies",
  "Materiaalfouten in door mij geleverde onderdelen, binnen de bovengenoemde termijnen",
];

export const garantieDekkingToelichting =
  "De garantie omvat kosteloos herstel of vervanging van het gebrekkige onderdeel, inclusief arbeid en voorrijkosten. Gevolgschade aan inboedel of andere bouwdelen valt onder mijn bedrijfsaansprakelijkheidsverzekering en wordt per situatie beoordeeld.";

export const garantieUitsluitingen = [
  "Normale slijtage, verkleuring, vergrijzing of verwering van hout door weersinvloeden",
  "Normale werking van hout: geringe krimp, zwel, kleine droogscheurtjes en noesten die loskomen; dit hoort bij een natuurlijk materiaal",
  "Achterstallig, onjuist of agressief onderhoud (bijvoorbeeld hogedrukreiniger op hout of kitwerk, verkeerde reinigings- of verfproducten)",
  "Schade veroorzaakt door derden, huisdieren, ongedierte of houtaantastende insecten en schimmels als gevolg van vocht van buitenaf",
  "Verzakking, werking of scheurvorming van de bestaande constructie, fundering of ondergrond",
  "Storm, hagel, brand, blikseminslag, overstroming en vandalisme",
  "Gebreken aan bestaande ondergronden, kozijnen, daken of constructies waar ik niet aan heb gewerkt",
  "Wijzigingen, reparaties of aanpassingen die later door anderen zijn uitgevoerd",
  "Buitenhoutwerk waarvan het schilder- en kitwerk niet volgens mijn onderhoudsadvies is bijgehouden",
  "Condensvorming of vocht die het gevolg is van onvoldoende ventilatie in de woning",
  "Thermische breuk van glas door externe oorzaken (bijvoorbeeld folie of zonwering te dicht op het glas)",
  "Door de klant zelf aangeleverde materialen of hout",
];

export const garantieVoorwaarden = [
  "De garantie geldt voor de opdrachtgever zoals vermeld op de factuur en gaat in op de datum van oplevering.",
  "De factuur is volledig betaald en de werkzaamheden zijn volgens mijn offerte uitgevoerd.",
  "Het onderdeel is normaal gebruikt en volgens mijn onderhoudsadviezen onderhouden (minimaal jaarlijks reinigen van houtwerk, kozijnen, glas en kitvoegen met een mild reinigingsmiddel).",
  "Voor buitenhoutwerk (kozijnen, deuren, gevelbekleding, boeidelen, dakkapellen, veranda's) geldt aanvullend: het schilder- of beitswerk wordt onderhouden volgens de termijn van het gebruikte product (doorgaans elke 4 tot 6 jaar voor dekkende verf en elke 2 tot 3 jaar voor transparante beits) en het kitwerk wordt elke 2 jaar gecontroleerd en waar nodig vervangen. Dit onderhoud kan ik in overleg voor je uitvoeren tegen een vooraf afgesproken tarief.",
  "Gebreken worden binnen 14 dagen na ontdekking bij mij gemeld, zodat vervolgschade wordt beperkt.",
  "Bij verkoop van de woning gaat de garantie over op de nieuwe eigenaar, mits de oorspronkelijke factuur en dit garantiebewijs worden overgedragen.",
];

export const garantieProcedure = [
  { titel: "Melden", tekst: "Meld het gebrek per e-mail, WhatsApp of telefoon. Stuur waar mogelijk foto's en het factuurnummer mee." },
  { titel: "Beoordeling", tekst: "Ik neem binnen 2 werkdagen contact met je op en plan indien nodig een inspectie op locatie." },
  { titel: "Herstel", tekst: "Valt het gebrek onder de garantie, dan herstel of vervang ik kosteloos. Spoedgevallen zoals een lekkage pak ik met voorrang op." },
  { titel: "Buiten garantie", tekst: "Valt het gebrek buiten de garantie, dan ontvang je vooraf een duidelijke offerte. Je beslist zelf of ik het oplos." },
];
